import script from "./AdministratorProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectTitle.vue?vue&type=style&index=0&id=48740f9b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48740f9b"]])

export default __exports__